$(document).ready(function() {
  /* Cookie functions
   * ======================================================= */
  function createCookie(name, value, days) {
    var expires;
    if (days) {
      var date = new Date();
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
      expires = "; expires=" + date.toGMTString();
    } else expires = "";
    document.cookie = name + "=" + value + expires + "; path=/";
  }

  function readCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(";");
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == " ") c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
  }

  function eraseCookie(name) {
    createCookie(name, "", -1);
  }

  /* Promobar Cookies
   * ======================================================= */

  // Check if Promobar Cookie Exists
  // If promobarClosed exists then remove promobar

  if ($(".promobar").length) {
    var promobarClosed = readCookie("promobarClosed");
    if (promobarClosed) {
      $(".promobar").remove();
    }

    $(".promobar .promoclose").click(function(event) {
      event.preventDefault();
      createCookie("promobarClosed", "true", 1);
      $(".promobar").remove();
    });

    $(".promobar .promolink").click(function(event) {
      createCookie("promobarClosed", "true", 1);
      $(".promobar").remove();
    });
  }

  /* =======================================================
  /* LOCATION BASED STUFF
  /* ======================================================= */

  var defaultState = "wa";
  var getState = readCookie("ll_state") || defaultState;
  var getCurrentURLPath = window.location.pathname.split("/");

  var $hiddenStates = {
    nsw: $(".hidden-nsw"),
    nt: $(".hidden-nt"),
    vic: $(".hidden-vic"),
    wa: $(".hidden-wa"),
    sa: $(".hidden-sa"),
    tas: $(".hidden-tas"),
    qld: $(".hidden-qld")
  };

  var $visibleStates = {
    nsw: $(".visible-nsw"),
    nt: $(".visible-nt"),
    vic: $(".visible-vic"),
    wa: $(".visible-wa"),
    sa: $(".visible-sa"),
    tas: $(".visible-tas"),
    qld: $(".visible-qld")
  };

  /**
   * GeoLocation content helper function
   * @param {String} state
   */
  function showGeoContentOnlyFrom(state) {
    var strState = String(state).toLowerCase();
    if (!$hiddenStates[strState]) {
      strState = defaultState;
    }
    // removes visible-state where state is not equal to state arg
    Object.keys($visibleStates)
      .filter(function(key) {
        return key !== strState;
      })
      .map(function(key) {
        return $visibleStates[key];
      })
      .forEach(function($visibleStateEl) {
        return $visibleStateEl.remove();
      });

    // removs hidden-state where state is equal to state arg
    $hiddenStates[strState].remove();

    // shows visible-state where state is equal to state arg
    $visibleStates[strState].show();
  }

  function isStringEqual(string1, string2) {
    return string1.toLowerCase() === string2.toLowerCase();
  }

  function smartRemoveLink(element, compare, onlyRemoveIfMatch) {
    if (element.parent().is(compare)) {
      element.parent().remove();
      return;
    }

    if (!onlyRemoveIfMatch) {
      element.remove();
    }
  }

  // init
  showGeoContentOnlyFrom(getState);

  // Show promobar (only for WA)
  function ShowPromoBar() {
    $(".promobar").css("display", "block");
  }

  // Remove supporters links (WA)
  // latest https://app.asana.com/0/0/1131619161317090/f
  function RemoveSupporters() {
    smartRemoveLink($('[href^="/supporters"]'), "li", true);
  }

  // Remove order resources links (NT)
  // latest https://app.asana.com/0/1200040426101917/1200237020154265/f
  function RemoveOrderResources() {
    smartRemoveLink($('[href^="/order/resources"]'), "li", false);
  }

  // Remove links to CurrentCampaign (all states, except WA)
  function RemoveLinkToCurrentCampaign() {
    smartRemoveLink(
      $('[href="/campaign-and-media/current-campaign"]'),
      "",
      false
    );
    smartRemoveLink(
      $('[href="/campaign-and-media/current-campaign"]'),
      "",
      false
    );
  }

  switch (getState) {
    case "NT":
      RemoveSupporters();
      RemoveOrderResources();
      RemoveLinkToCurrentCampaign();
      break;
    case "VIC":
      RemoveLinkToCurrentCampaign();
      break;
    default:
    case "WA":
      ShowPromoBar();
      RemoveSupporters();
      break;
  }
});
